// extracted by mini-css-extract-plugin
module.exports = {"title":"TopBarTitles_title__xxGM1","subtitle":"TopBarTitles_subtitle__3MpYX"};